import { render, staticRenderFns } from "./KillBars.vue?vue&type=template&id=47e695ce&scoped=true&"
import script from "./KillBars.vue?vue&type=script&lang=js&"
export * from "./KillBars.vue?vue&type=script&lang=js&"
import style0 from "./KillBars.vue?vue&type=style&index=0&id=47e695ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e695ce",
  null
  
)

export default component.exports